import React from 'react';

function UserProfileView() {
    return (
        <div className="messaging__user-profile">
            <h1>Noman Gazi</h1>
        </div>
    );
}

export default UserProfileView;
